import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProcessGroupCategorieEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class EvProcessGroupCategorieEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvProcessGroupCategorie;
    }

    protected beforeDelete() {
        let processGroups = this.getAttributeValue("EL_event_process_group_ev_process_group_categorie");
        if (processGroups && processGroups.length > 0) {
            this.showToast(this.translate("EvProcessGroupCategorie_Error_NoDelete"), "fas fa-exclamation-triangle");
            return;
        }
        super.beforeDelete.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProcessGroupCategorieEditor);